import { type Point, point } from '../../../elements';
import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createSquareNodeTypeIcon,
  getArrowSvgPath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createLbIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const drawArrow = (from: Point, to: Point) =>
    makeTag('path', {
      d: getArrowSvgPath({
        from,
        to,
        headWidth: 5.6,
        headHeight: 5.6,
        headSkew: 0.8,
        tailWidth: 1.6,
      }),
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    });

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    ${drawArrow(point.create(2.4, 20), point.create(12.4, 20))}
    ${drawArrow(point.create(26.8, 13.2), point.create(36.4, 6.4))}
    ${drawArrow(point.create(27.2, 20), point.create(36.8, 20))}
    ${drawArrow(point.create(26.8, 26.8), point.create(36.4, 33.6))}
    ${makeTag('circle', {
      cx: 20,
      cy: 20,
      r: 4.4,
      fill: 'none',
      stroke: ICON_DEFAULT_FOREGROUND_COLOR,
      'stroke-width': 2,
    })}
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const lbIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createLbIcon,
);
